import React, {PureComponent} from 'react';
import {Col, Modal, Row} from "react-bootstrap";
import {deepCopyObject, getCustomersNative, showAxiosError} from "../../../helper/helper";
import Select from "../../../local_node_modules/react-select";
import Table from "../../../components/Table/Table";
import {request} from "../../../helper/APIUtils";

class AssignCustomerModal extends PureComponent {

	constructor(props) {
		super(props);

		this.state = {
			key: Math.random().toString(),
			customers: [],
			assignedCustomers: this.props.assignedCustomers,
			notify: null
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.assignedCustomers !== this.state.assignedCustomers) {
			let customers = this.state.assignedCustomers;
			this.setState({
				customers
			})
		}
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		if (nextProps.assignedCustomers !== prevState.assignedCustomers) {
			return {assignedCustomers: nextProps.assignedCustomers}
		} else {
			return null;
		}
	}

	addCustomer(e) {
		let customers = deepCopyObject(this.state.customers);
		let customer = JSON.parse(e.value);

		if (customers.length === 0) {
			customers.push(customer);
			this.setState({
				customers
			})
		} else {
			let found = false;
			for (let i = 0; i < customers.length; i++) {
				if (customers[i].recordId === customer.recordId) {
					found = true;
					break;
				}
			}

			if (!found) {
				customers.push(customer);
				this.setState({
					customers
				})
			}
		}
	}

	submitAssignment() {
		let customers = this.state.customers;
		let selectedAccountant = this.props.selectedAccountant;
		let self = this;

		let assignedCustomers = [];
		if (customers.length > 0) {
			customers.map(c => {
				let newAssignment = {};
				newAssignment.accountantCustomer = selectedAccountant;
				newAssignment.assignedCustomer = c.recordId;
				assignedCustomers.push(newAssignment);
			});

			let params = {
				url: `/customer/assignCustomersToAccountant`,
				method: 'post',
				data: assignedCustomers
			};
			request(params).then(() => {
				self.props.closeAssignModal();
			}).then(() => {
				self.props.showNotification('success', 'Müşteri atama / çıkartma işlemi başarılı');
			})
				.catch(function (error) {
					showAxiosError(error);
				});
		} else {
			self.props.closeAssignModal();
		}
	}

	removeCustomerFromAccountant(row) {
		let self = this;
		let params = {
			url: `/customer/removeCustomerFromAccountant`,
			method: 'post',
			data: row.recordId,
		};
		request(params).then(() => {
			self.removeCustomerFromCustomerList(row);
		}).then(() => {
			self.props.showNotification('success', 'Müşteri çıkartıldı');
		}).catch(function (error) {
			showAxiosError(error);
		});
	}

	removeCustomerFromCustomerList(row) {
		let customers = deepCopyObject(this.state.customers);

		let newCustomerList =  customers.filter(c => {
			return c.recordId !== row.recordId;
		});

		this.setState({
			customers: newCustomerList
		})
	};

	render() {

		const columns = [
			{
				Header: "Unvan",
				accessor: "formattedName"
			},
			{
				Header: "VKN/TCKN",
				accessor: "vknTckn"
			},
			{
				Header: "Kurumsal e-Posta",
				accessor: "corporateMail"
			},
			{
				Header: "İşlemler",
				accessor: "",
				Cell: (row) => (
					<button className='simpleButton trash'
							onClick={() => this.removeCustomerFromAccountant(row)}/>
				)
			}
		];

		return (
			<Modal show={this.props.show}
				   animation={false}
				   toggle={() => this.props.closeModal()}
				   modalTransition={{timeout: 700}}
				   dialogClassName="modal-90w"
				   size="lg"
				   backdropTransition={{timeout: 1300}}
				   aria-labelledby="example-custom-modal-styling-title"
				   backdrop="static">

				<Modal.Header style={{paddingBottom: '15px'}}>
					<Modal.Title id="example-custom-modal-styling-title"
								 className='col-xs-12 col-sm-10 col-md-10 col-lg-10 col-xl-10'
								 style={{
									 marginBottom: '0',
									 fontSize: '1em',
									 lineHeight: '2em',
									 fontWeight: 'normal'
								 }}>
						<label style={{color: 'white', fontFamily: 'Montserrat', fontWeight: 'normal'}}>{this.props.title}</label>
					</Modal.Title>
					<div>
						<button className='fas fa-times simpleButton'
								style={{
									position: 'unset',
									right: '0',
									top: '0',
									outline: '0',
									background: 'transparent'
								}}
								onClick={() => this.props.closeAssignModal()}/>
					</div>
				</Modal.Header>

				<Modal.Body>

					<Row>
						<Col xs="12">
							<label>Unvan, Vergi Kimlik Numarası veya "TC Kimlik Numarası" ile arama yapabilirsiniz. (En az 3 karakter)</label>
						</Col>
					</Row>

					<Row>
						<Col xs="12">
							<Select.Async multi={false}
										  ignoreAccents={false}
										  value={""}
										  onChange={(e) => this.addCustomer(e)}
										  isLoading={true}
										  autoload={false}
										  cache={false}
										  clearable={false}
										  filterOptions={(options) => options}
										  noResultsText="Kayıt bulunamadı."
										  searchPromptText="Arama için en az 3 karakter giriniz."
										  placeholder="VKN/TCKN ile ara..."
										  loadingPlaceholder="Yükleniyor..."
										  loadOptions={getCustomersNative}/>
						</Col>
					</Row>
				</Modal.Body>

				<Modal.Body style={{padding: '10px 30px 10px 30px'}}>
					<hr style={{margin: '0'}}/>
				</Modal.Body>

				<Modal.Body style={{padding: '15px 23px 30px 23px'}}>
					<Row>
						<Col xs="12" key={this.state.key}>
							<Table columns={columns}
								   content={this.state.customers}
								   total={this.state.length}
								// page={this.state.page}
								// manual={this.state.manual}
								// size={this.state.size}
								// options={["5", "10", "20", "50"]}
								// fetchData={this.fetchBranchList}
								   paginationEnabled={false}
							/>
						</Col>
					</Row>
				</Modal.Body>

				<Modal.Footer>
						<Col xs='12' style={{textAlign: 'right'}}>
							<button className='simpleButton' onClick={() => this.submitAssignment()}>
								Onayla
							</button>
						</Col>
				</Modal.Footer>
			</Modal>
		)
	}
}

export default AssignCustomerModal;